import React, { useState, useEffect, useRef } from 'react';
import { MdSports, MdSportsSoccer, MdSportsBasketball, MdSportsRugby, MdSportsHockey } from 'react-icons/md';
import { FaFootballBall, FaBaseballBall, FaVolleyballBall } from 'react-icons/fa';
import { IoIosAmericanFootball } from 'react-icons/io';
import { Circle } from 'lucide-react';
const getTeamIcon = (sport) => {
  
  switch (sport.toLowerCase()) {
    case 'gaelic football':
      return <MdSports className="h-5 w-5 mr-2 inline-block" />; // Shield to represent the defensive nature of Gaelic football
    case 'hurling':
    case 'camogie':
      return <Circle className="h-5 w-5 mr-2 inline-block" />; // Circle to represent the sliotar (ball used in hurling/camogie)
    case 'rugby':
      return <MdSportsRugby className="h-5 w-5 mr-2 inline-block" />;
    case 'soccer':
      return <MdSportsSoccer className="h-5 w-5 mr-2 inline-block" />;
    case 'hockey':
      return <MdSportsHockey className="h-5 w-5 mr-2 inline-block" />;
    case 'basketball':
      return <MdSportsBasketball className="h-5 w-5 mr-2 inline-block" />;
    default:
      return <MdSports className="h-5 w-5 mr-2 inline-block" />; // Generic team sport icon for any unspecified sports
  }
};

const TruncatedTeamsList = ({ teams }) => {
  const [displayItems, setDisplayItems] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust this breakpoint as needed
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const updateDisplayItems = () => {
      if (!containerRef.current || !teams.length) return;

      const container = containerRef.current;
      const containerWidth = container.offsetWidth;

      if (isMobile) {
        setDisplayItems([
          <span key="mobile-ellipsis" className="text-gray-500">...</span>
        ]);
        return;
      }

      let currentWidth = 0;
      const items = [];

      for (let i = 0; i < teams.length; i++) {
        const team = teams[i];
        const itemContent = (
          <React.Fragment key={i}>
            {getTeamIcon(team.sport)}
            <span className="align-middle">{`${team.team_name} `}</span>
          </React.Fragment>
        );

        const tempSpan = document.createElement('span');
        tempSpan.innerHTML = `${team.team_name}`;
        document.body.appendChild(tempSpan);
        const itemWidth = tempSpan.offsetWidth + 30; // Add extra width for icon and spacing
        document.body.removeChild(tempSpan);

        if (currentWidth + itemWidth > containerWidth) {
          if (i > 0) {
            items.push(<span key="ellipsis" className="text-gray-500">...</span>);
          }
          break;
        }

        items.push(itemContent);
        currentWidth += itemWidth;

        if (i < teams.length - 1) {
          items.push(<span key={`separator-${i}`}>, </span>);
          currentWidth += 10; // Estimated width for comma and space
        }
      }

      setDisplayItems(items);
    };

    updateDisplayItems();
    window.addEventListener('resize', updateDisplayItems);
    return () => window.removeEventListener('resize', updateDisplayItems);
  }, [teams, isMobile]);

  return (
    <div
      ref={containerRef}
      className="whitespace-nowrap overflow-hidden text-ellipsis"
      title={teams.map(team => `${team.sport} (${team.team_category})`).join(', ')}
    >
      {displayItems}
    </div>
  );
};

export default TruncatedTeamsList;